export function cn(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}

/**
 * Parse a UTC timestamp string from the database.
 * Database stores UTC timestamps without timezone indicator,
 * so we append 'Z' to tell JavaScript to parse as UTC.
 */
export function parseUTCDate(dateString: string): Date {
  const utcString = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
  return new Date(utcString);
}

/**
 * Format a timestamp as relative time (e.g., "5m ago", "2h ago")
 */
export function formatTimeAgo(dateString: string): string {
  const date = parseUTCDate(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
}

/**
 * Format a UTC timestamp as a localized date string
 */
export function formatDate(dateString: string, options?: Intl.DateTimeFormatOptions): string {
  const date = parseUTCDate(dateString);
  return date.toLocaleDateString(undefined, options);
}

/**
 * Format a UTC timestamp as a localized date and time string
 */
export function formatDateTime(dateString: string, options?: Intl.DateTimeFormatOptions): string {
  const date = parseUTCDate(dateString);
  return date.toLocaleString(undefined, options);
}
